import Header from '../components/Header';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-serif text-xl text-white font-bold mb-3">{title}</h2>
    <div className="text-white/75 text-sm leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function PrivacyPage() {
  return (
    <div className="min-h-screen relative">
      <div className="fixed inset-0 -z-10 bg-gradient-to-br from-ocean via-ocean-light/90 to-sky/70" />
      <Header />
      <main className="pt-24 pb-20 px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-xl border border-white/15 rounded-2xl p-6 sm:p-10" data-testid="privacy-page">
          <h1 className="font-serif text-3xl text-white font-bold mb-2">Privacy Policy</h1>
          <p className="text-white/50 text-sm mb-8">Last updated: April 2026</p>

          <Section title="1. Information We Collect">
            <p><strong className="text-white">Account Information:</strong> When you register, we collect your name, email address, phone number, and nationality to personalise your travel experience.</p>
            <p><strong className="text-white">Trip Data:</strong> Destination preferences, travel dates, budget parameters, number of travellers, and itinerary details you provide during trip planning.</p>
            <p><strong className="text-white">Uploaded Content:</strong> Photos, reviews, and captions you upload to the Photo Journal feature.</p>
            <p><strong className="text-white">Usage Data:</strong> Pages visited, features used, search queries, and interaction patterns to improve our service.</p>
          </Section>

          <Section title="2. How We Use Your Information">
            <p>We use your information to:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Generate personalised AI-powered travel itineraries</li>
              <li>Provide accurate budget estimates and currency conversions</li>
              <li>Send trip reminders and travel notifications</li>
              <li>Display relevant booking options through affiliate partners</li>
              <li>Improve our AI models and user experience</li>
              <li>Respond to your enquiries and provide support</li>
            </ul>
          </Section>

          <Section title="3. Third-Party Services">
            <p>Our platform integrates with the following third-party services that may receive or process your data:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li><strong className="text-white">Google (Places API, Gemini AI):</strong> For destination photos and AI-powered itinerary generation</li>
              <li><strong className="text-white">Pexels:</strong> For supplementary travel imagery</li>
              <li><strong className="text-white">Expedia, Booking.com, Aviasales:</strong> When you click affiliate booking links (subject to their privacy policies)</li>
              <li><strong className="text-white">ExchangeRate-API:</strong> For real-time currency conversion</li>
            </ul>
            <p>We do not sell your personal information to any third party.</p>
          </Section>

          <Section title="4. Data Storage & Security">
            <p>Your data is stored securely using industry-standard encryption and access controls. Account passwords are hashed using bcrypt. We retain your data for as long as your account is active or as needed to provide services.</p>
            <p>Uploaded photos are stored in secure cloud object storage with access restricted to authenticated account owners.</p>
          </Section>

          <Section title="5. Cookies">
            <p>We use essential cookies and local storage tokens for authentication and session management. We do not use third-party tracking cookies for advertising purposes.</p>
          </Section>

          <Section title="6. Your Rights">
            <p>You have the right to:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Access and download your personal data</li>
              <li>Update or correct your account information</li>
              <li>Delete your account and associated data</li>
              <li>Opt out of marketing communications</li>
            </ul>
            <p>To exercise these rights, contact us at <a href="mailto:triplea@tripleabooking.com" className="text-gold hover:underline">triplea@tripleabooking.com</a>.</p>
          </Section>

          <Section title="7. Children's Privacy">
            <p>Our Service is not directed to individuals under the age of 16. We do not knowingly collect personal information from children.</p>
          </Section>

          <Section title="8. Changes to This Policy">
            <p>We may update this Privacy Policy from time to time. We will notify users of significant changes via email or in-app notification.</p>
          </Section>

          <Section title="9. Contact">
            <p>For privacy-related enquiries, contact us at <a href="mailto:triplea@tripleabooking.com" className="text-gold hover:underline">triplea@tripleabooking.com</a> or call +61 401 050 457.</p>
          </Section>
        </div>
      </main>
    </div>
  );
}
